"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationSubscriber = void 0;
var PushNotificationPayload_1 = require("../payloads/PushNotificationPayload");
var Subscriber_1 = require("../Subscriber");
var PushNotificationTopic_1 = require("../topics/PushNotificationTopic");
var PushNotificationSubscriber = /** @class */ (function (_super) {
    __extends(PushNotificationSubscriber, _super);
    function PushNotificationSubscriber(client, logger, args) {
        var topic = new PushNotificationTopic_1.PushNotificationTopic();
        return _super.call(this, client, logger, PushNotificationPayload_1.PushNotificationPayload, __spreadArray([
            topic.topicsFor(args),
            topic.topicsFor({ userUuid: args.userUuid })
        ], (args.siteUuid != null ? [topic.topicsFor({ siteUuid: args.siteUuid })] : []), true).flat()) || this;
    }
    return PushNotificationSubscriber;
}(Subscriber_1.Subscriber));
exports.PushNotificationSubscriber = PushNotificationSubscriber;
//# sourceMappingURL=PushNotificationSubscriber.js.map